import * as views from './sections/views';

export default views;
